import { Component } from '@angular/core';
import { StockDetailService } from '../../../../Services/Stock-Details/stock-detail.service';
import { AuthService } from '../../../../Services/auth.service';
import { HttpParams } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

interface StockItem {
  std_item_code: string;
  std_barcode: string;
  std_item_category: string;
  std_total_wt: number;
  std_quantity: number;
  owner: string;
  std_entry_date: string;
  std_return_reason?: string | null;
  std_returned_at?: string | null;
  returned_by_staff_id?: number | null;
  status: 'Assigned' | 'Pending' | 'Submitted' | 'Sold';
}

@Component({
  selector: 'app-submitted-stock',
  imports: [CommonModule, FormsModule],
  templateUrl: './submitted-stock.component.html',
  styleUrl: './submitted-stock.component.css'
})
export class SubmittedStockComponent {

  constructor(private stockDetailService:StockDetailService,private authService:AuthService){}
  
  // Pagination State
  currentPage: number = 1;
  itemsPerPage: number = 10;

  // dummy data generator (24 items to show 3 pages)
  stockItems: any;

  ngOnInit(){
    this.getNewStockData();
  }

  getNewStockData() {
    let params = new HttpParams()
      .set('returned_by_staff_id', this.authService.getUserId());

    this.stockDetailService.getStockDetails(params).subscribe((response: any) => {
      this.stockItems = response.data || [];
      this.currentPage = 1;
      console.log('submitted stock data:', this.stockItems);
    });
  }

  // Getters for Pagination
  get visibleItems(): StockItem[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.stockItems.slice(startIndex, startIndex + this.itemsPerPage);
  }

  get totalItems(): number {
    return this.stockItems.length;
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / this.itemsPerPage);
  }

  get startRange(): number {
    if (this.totalItems === 0) return 0;
    return (this.currentPage - 1) * this.itemsPerPage + 1;
  }

  get endRange(): number {
    return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  }

  // Navigation Methods
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }
  
  firstPage() {
    this.currentPage = 1;
  }

  lastPage() {
    this.currentPage = this.totalPages;
  }
}